import { useDeviceType } from '@cian/ui-kit';
import React, { useEffect } from 'react';
import cn from 'clsx';
import { IPersonalizedOfferProps, PersonalizedOffer } from '../PersonalizedOffer';
import { IOfferCardProps, OfferCard } from '../OfferCard';
import { MultiOfferContainer } from 'shared/containers/MultiOfferContainer';
import { EMappedTypeOffer } from '../../constants/mapOfferTypes';
import styles from './styles.css';
import { ICalculatorMcfValues } from 'shared/types/features';
import { MortgageOfferEmpty } from '../MortgageOfferEmpty';
import { Loader } from '../Loader';
import { useGetMappedOffers } from '../../hooks/useGetMappedOffers';
import { useTracking } from '../../utils/tracking/useTracking';
import { getObjectForAnalyticsAboutShowingOffers } from '../../utils/tracking/utils/getObjectForAnalyticsAboutShowingOffers';

export interface IOfferListProps {
  calculatorValues: ICalculatorMcfValues;
}

type TMapComponents = Record<
  EMappedTypeOffer,
  (props: IPersonalizedOfferProps | IOfferCardProps | IOfferCardProps[]) => React.ReactElement | null
>;

const mapComponents: TMapComponents = {
  personalized: (props: IPersonalizedOfferProps) => <PersonalizedOffer {...props} />,
  offer: (props: IOfferCardProps) => <OfferCard {...props} />,
  multi: (props: IOfferCardProps[]) => <MultiOfferContainer multiOffers={props} />,
};

export const OfferList: React.FC<IOfferListProps> = ({ calculatorValues }) => {
  const { trackShowOffers } = useTracking();
  const deviceType = useDeviceType();
  const { mappedOffers, isFetching } = useGetMappedOffers(calculatorValues);

  useEffect(() => {
    if (!isFetching) {
      trackShowOffers(getObjectForAnalyticsAboutShowingOffers(mappedOffers));
    }
  }, [isFetching]);

  if (isFetching) {
    return <Loader text={'Загружаем лучшие предложения...'} />;
  }

  if (mappedOffers.length === 0) {
    return <MortgageOfferEmpty />;
  }

  return (
    <ul className={cn(styles['wrapper'], styles[deviceType])}>
      {mappedOffers.map(({ type, content }, index) => {
        return <li key={index}>{mapComponents[type](content)}</li>;
      })}
    </ul>
  );
};
